import Vue from 'vue'

Vue.filter('titleCase', value => {
  if (!value) {
    return ''
  } else {
    let str = ''
    let arr = value.split('_')
    for (let i = 0; i < arr.length; i++) {
      if (i === 0) {
        str = arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase()
      } else {
        str = ' ' + arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase()
      }
    }

    return str
  }
})
